import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/pageLayout/layout';
import page404 from '@/pageLayout/404page';

Vue.use(Router);
// 解决产品服务子目录name相同跳转报错问题
const changePush = Router.prototype.push;
Router.prototype.push = function push(location){
    return changePush.call(this, location).catch(err => err);
}
export const constantRouterMap = [
	{ path: '/', name: 'default', redirect: '/mainPage', hidden: true },
];

export const routerMap = [
	{
		path: '/aboutUs',
		name: 'aboutUs',
		component: Layout,
		meta: { title: '关于我们', icon: 'el-icon-office-building', value: 'ABOUT_US'},
		children: [
			{
				path: '/aboutUs/companyProfile',
				name: 'companyProfile',
				component: () => import('@/applyPages/aboutUs/companyProfile'),
				meta: { title: '公司简介', icon: '' ,value: 'COMPANY_INTRODUCTION'},
			},
			{
				path: '/aboutUs/companyHonor',
				name: 'companyHonor',
				component: () => import('@/applyPages/aboutUs/companyHonor'),
				meta: { title: '公司荣誉', icon: '', value: 'COMPANY_HONOR' },
			},
			{
				path: '/aboutUs/developmentStrategy',
				name: 'developmentStrategy',
				component: () => import('@/applyPages/aboutUs/developmentStrategy'),
				meta: { title: '发展战略', icon: '', value: 'DEVELOPMENT_STRATEGY'},
			},
			{
				path: '/aboutUs/corporateCulture',
				name: 'corporateCulture',
				component: () => import('@/applyPages/aboutUs/corporateCulture'),
				meta: { title: '企业文化', icon: '', value: 'COMPANY_CULTURE' },
			},
			{
				path: '/aboutUs/technicalPatent',
				name: 'technicalPatent',
				component: () => import('@/applyPages/aboutUs/technicalPatent'),
				meta: { title: '技术专利', icon: '', value: 'TECHNOLOGY_PATENT' },
			},
			{
				path: '/aboutUs/developmentHistory',
				name: 'developmentHistory',
				component: () => import('@/applyPages/aboutUs/developmentHistory'),
				meta: { title: '发展历程', icon: '', value: 'DEVELOPMENT_HISTORY' },
			},
			{
				path: '/aboutUs/organizationalStructure',
				name: 'organizationalStructure',
				component: () => import('@/applyPages/aboutUs/organizationalStructure'),
				meta: { title: '组织架构', icon: '', value: 'ORGANIZATION' },
			},
		],
	},
	{
		path: '/newsCenter',
		name: 'newsCenter',
		component: Layout,
		meta: { title: '新闻中心', icon: 'el-icon-office-building' ,value: 'NEWS_CENTER' },
		children: [
			{
				path: '/newsCenter/companyDynamics',
				name: 'companyDynamics',
				component: () => import('@/applyPages/newsCenter/companyDynamics'),
				meta: { title: '公司动态', icon: '', value: 'COMPANY_DYNAMIC' },
			},
			{
				path: '/newsCenter/companyDynamicsDetails',
				name: 'companyDynamicsDetails',
				component: () => import('@/applyPages/newsCenter/companyDynamicsDetails'),
				meta: { title: '公司动态详情', icon: '' },
				hidden: true,
			},
			{
				path: '/newsCenter/InformationDisclosure',
				name: 'InformationDisclosure',
				component: () => import('@/applyPages/newsCenter/InformationDisclosure'),
				meta: { title: '信息公开', icon: '', value: 'MSG_DISCLOSURE' },
			},
			{
				path: '/newsCenter/InformationDisclosureDetails',
				name: 'InformationDisclosureDetails',
				component: () => import('@/applyPages/newsCenter/InformationDisclosureDetails'),
				meta: { title: '信息公开详情', icon: '' },
				hidden: true,
			},
		],
	},
	{
		path: '/productService',
		name: 'productService',
		component: Layout,
		meta: { title: '产品服务', icon: 'el-icon-office-building' ,value: 'PRODUCT_SERVICE' },
		children: [
			{
				path: '/productService/productService',
				name: 'productServices',
				component: () => import('@/applyPages/productService/productService'),
				meta: { title: '产品服务', icon: '' },
			},
			{
				path: '/productService/productIntroduction',
				name: 'productIntroduction',
				component: () => import('@/applyPages/productService/productIntroduction'),
				meta: { title: '产品平台', icon: '' },
				hidden: true,
			},
		],
	},
	{
		path: '/personnelRecruitment',
		name: 'personnelRecruitment',
		component: Layout,
		meta: { title: '人才招聘', icon: 'el-icon-office-building', value: 'RECRUITMENT' },
		children: [
			{
				path: '/personnelRecruitment/personnelRecruitment',
				name: 'personnelRecruitment',
				component: () => import('@/applyPages/personnelRecruitment/personnelRecruitment'),
				meta: { title: '招聘信息', icon: '', value: 'RECRUITMENT_INFO' },
			}, {
				path: '/personnelRecruitment/recruitmentDetails',
				name: 'recruitmentDetails',
				component: () => import('@/applyPages/personnelRecruitment/recruitmentDetails'),
				meta: { title: '招聘详情', icon: '', },
				hidden: true,
			},{
				path: '/personnelRecruitment/recruitmenAnnouncement',
				name: 'recruitmenAnnouncement',
				component: () => import('@/applyPages/personnelRecruitment/recruitmenAnnouncement'),
				meta: { title: '招聘公告', icon: '', value: 'RECRUITMENT_ANNOUNCEMENT' },
			},{
				path: '/personnelRecruitment/announcementDetails',
				name: 'announcementDetails',
				component: () => import('@/applyPages/personnelRecruitment/announcementDetails'),
				meta: { title: '公告详情', icon: '', },
				hidden: true,
			},
		],
	},
	{
		path: '/information',
		name: 'information',
		component: Layout,
		meta: { title: '联系我们', icon: 'el-icon-office-building', value: 'CONNECT_US' },
		children: [
			{
				path: '/information',
				name: 'information',
				component: () => import('@/applyPages/contactZYBD/information'),
				meta: { title: '联系我们', icon: '' },
			},
		],
	},

	{
		path: '/mainPage',
		name: 'mainPage',
		component: Layout,
		meta: { title: 'common', icon: '', value: 'FRONT_PAGE' },
		hidden: true,
		children: [
			{
				path: '/mainPage',
				name: 'mainPage',
				component: () => import('@/applyPages/mainPage'),
				meta: { title: 'mainPage', icon: '' },
				hidden: true,
			},
		],
	},
	// { path: '*', redirect: '/common/404', hidden: true },
];

export default new Router({
	// scrollBehavior: () => ({ y: 0 }),
	routes: constantRouterMap,
});



// WEBPACK FOOTER //
// ./src/router/index.js